import React, { useState } from 'react';
import "./Nav.css";
import 'boxicons/css/boxicons.min.css';
import logoImg from '../../assets/logo.png';
import logo2Img from '../../assets/logo2.png';

function Nav() {
  const [navActive, setNavActive] = useState(false);
  const [activeLink, setActiveLink] = useState('home');

  const [theme, setTheme] = useState('dark');

  // Load theme from localStorage on initial render
  React.useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      setTheme('light');
      document.body.classList.add('light-mode');
    } else {
      // Default: dark mode
      setTheme('dark');
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
    }
  }, []);

  const toggleTheme = () => {
    if (theme === 'dark') {
      setTheme('light');
      document.body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    } else {
      setTheme('dark');
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
    }
  };

  const toggleNavbar = () => {
    setNavActive(!navActive);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setNavActive(false); // 👈 close menu on mobile
  };

  return (
    <header className="header">
      <a href="#home" className="logo" onClick={() => handleLinkClick('home')}>
        <div className="logo-img">
          <img src={theme === 'light' ? logo2Img : logoImg} alt="Hiruni Wijerathna" />
        </div>
      </a>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <nav className={`navbar ${navActive ? 'active' : ''}`}>
          <a
            href="#home"
            className={activeLink === 'home' ? 'active' : ''}
            onClick={() => handleLinkClick('home')}
          >
            Home
          </a>

          <a
            href="#services"
            className={activeLink === 'services' ? 'active' : ''}
            onClick={() => handleLinkClick('services')}
          >
            Services
          </a>

          <a
            href="#resume"
            className={activeLink === 'resume' ? 'active' : ''}
            onClick={() => handleLinkClick('resume')}
          >
            Resume
          </a>

          <a
            href="#portfolio"
            className={activeLink === 'portfolio' ? 'active' : ''}
            onClick={() => handleLinkClick('portfolio')}
          >
            Projects
          </a>

          <a
            href="#contact"
            className={activeLink === 'contact' ? 'active' : ''}
            onClick={() => handleLinkClick('contact')}
          >
            Contact
          </a>
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginLeft: '2rem' }}>
          <label className="theme-switch" htmlFor="checkbox">
            <input 
              type="checkbox" 
              id="checkbox" 
              onChange={toggleTheme} 
              checked={theme === 'light'} 
            />
            <div className="slider round">
              <i className="bx bx-sun sun-icon"></i>
              <i className="bx bx-moon moon-icon"></i>
            </div>
          </label>

          <i
            className={`bx ${navActive ? 'bx-x' : 'bx-menu'}`}
            id="menu-icon"
            onClick={toggleNavbar}
          ></i>
        </div>
      </div>
    </header>
  );
}

export default Nav;
